import React, { useEffect, useContext, useState } from 'react';
import intl from 'react-intl-universal';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';
import { toOrderPage } from 'utils/util';

interface IOrderButton {}

const OrderButton = (props: IOrderButton) => {
  return (
    <NormalButton
      onClick={() => {
        stat.event('button_order');
        toOrderPage('from_order_pendant');
      }}
    >
      {intl.get('Preorder')}
    </NormalButton>
  );
};

export default OrderButton;
